<div class="form-container service-form ms-large-t" #formContainer>
  <!-- Initial form state -->
  <form
    *ngIf="reactiveForm && (formStatus === FormStatus.INITIAL || formStatus === FormStatus.ERROR)"
    [formGroup]="reactiveForm"
    [finFormErrorFocus]="reactiveForm"
    (ngSubmit)="onSubmit()"
  >
    <!-- Error notification -->
    <fcom-notification
      *ngIf="formStatus === FormStatus.ERROR"
      class="mr-medium-b"
      [layout]="NotificationLayout.BLOCK"
      [theme]="NotificationTheme.ALERT"
    >
      {{ 'SERVICE_FORMS.NTServiceForms.error.title' | finLocalization }}
    </fcom-notification>
    <p class="font-body-1 nordic-blue-900-text pr-medium-b">
      {{ 'SERVICE_FORMS.NTServiceForms.mandatoryFields' | finLocalization }}
    </p>
    <h3 id="first">{{ 'SERVICE_FORMS.NTServiceForms.baggageTrackingForm.pirHeading' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'baggageReferenceNumber'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.baggageReferenceNumber'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.baggageReferenceNumber.note'"
      ></fcom-text-input>
    </div>
    <h3 id="first">{{ 'SERVICE_FORMS.NTServiceForms.baggageTrackingForm.passengerHeading' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'firstName'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.firstName'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'lastName'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.lastName'"
      ></fcom-text-input>
      <fin-select-input
        [parentForm]="reactiveForm"
        [controlName]="'phonePrefix'"
        [options]="phonePrefixes$ | async"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.phonePrefix'"
      ></fin-select-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'phoneNumber'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.phoneNumberDigits.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.phoneNumberDigits'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'email'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.email'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'homeAddress'"
        [isSensitive]="true"
        [type]="TextInputType.TEXTAREA"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.homeAddress'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'temporaryAddress'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.temporaryAddress'"
        [isSensitive]="true"
        [type]="TextInputType.TEXTAREA"
      ></fcom-text-input>
      <fin-datepicker
        *ngIf="reactiveForm.get('temporaryAddress').value.length > 0"
        [parentForm]="reactiveForm"
        [controlName]="'temporaryAddressValidFrom'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.temporaryAddressValidFrom.placeholder'"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.temporaryAddressValidFrom'"
        [theme]="datepickerThemes.WEB_2"
      ></fin-datepicker>
      <fin-datepicker
        *ngIf="reactiveForm.get('temporaryAddress').value.length > 0"
        [parentForm]="reactiveForm"
        [controlName]="'temporaryAddressValidTo'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.temporaryAddressValidTo.placeholder'"
        [minDate]="toMinDate"
        [maxDate]="maxDate"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.temporaryAddressValidTo'"
        [theme]="datepickerThemes.WEB_2"
      ></fin-datepicker>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'cardNumber'"
        [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.cardNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.cardNumber'"
      ></fcom-text-input>
    </div>
    <div class="flex form-subgroup">
      <fcom-radio-item-group
        [options]="finnairPlusTierOptions"
        [parentForm]="reactiveForm"
        [controlName]="'finnairPlusTier'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.finnairPlusTier'"
      >
      </fcom-radio-item-group>
    </div>
    <h3>{{ 'SERVICE_FORMS.NTServiceForms.baggageTrackingForm.iteneraryHeading' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fin-form-array
        [parentForm]="reactiveForm"
        [controlName]="'itenerary'"
        [maxGroups]="4"
        [minGroups]="1"
        [formGroupConfig]="iteneraryFormGroupConfig"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.itenerary'"
      >
        <ng-template let-parentItenerary="parentFormGroup" let-index="index">
          <div class="flex flex--row flex--wrap form-subgroup">
            <fcom-text-input
              [parentForm]="parentItenerary"
              [controlName]="'origin'"
              [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.origin'"
              [id]="'itenerary_' + (index + 1) + '_origin'"
            ></fcom-text-input>
            <fcom-text-input
              [parentForm]="parentItenerary"
              [controlName]="'destination'"
              [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.destination'"
              [id]="'itenerary_' + (index + 1) + '_destination'"
            ></fcom-text-input>
            <fcom-text-input
              [parentForm]="parentItenerary"
              [controlName]="'flightNumber'"
              [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.flightNumber'"
              [id]="'itenerary_' + (index + 1) + '_flightNumber'"
            ></fcom-text-input>
            <fin-datepicker
              [parentForm]="parentItenerary"
              [controlName]="'flightDate'"
              [id]="'itenerary_' + (index + 1) + '_flightDate'"
              [placeHolder]="'SERVICE_FORMS.NTServiceForms.fields.flightDate.placeholder'"
              [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.flightDate'"
              [theme]="datepickerThemes.WEB_2"
            ></fin-datepicker>
          </div>
        </ng-template>
      </fin-form-array>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'baggageLastSeen'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.baggageLastSeen'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'numberOfPiecesChecked'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.numberOfPiecesChecked'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'baggageIdentificationTagNumbers'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.baggageIdentificationTagNumbers'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'whenAndWhereLossReported'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.whenAndWhereLossReported'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'anythingParticularAtCheckIn'"
        [type]="TextInputType.TEXTAREA"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.anythingParticularAtCheckIn'"
      ></fcom-text-input>
    </div>
    <h3>{{ 'SERVICE_FORMS.NTServiceForms.baggageTrackingForm.descriptionOfBagHeading' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'color'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.color'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'brand'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.brand'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'typeOfBag'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.typeOfBag'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-radio-item-group
        [options]="[{ value: 'hard' }, { value: 'soft' }]"
        [parentForm]="reactiveForm"
        [controlName]="'bagWasHard'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.bagWasHard'"
      >
      </fcom-radio-item-group>
      <label class="font-body-1 nordic-blue-900-text flex--basis-full ms-xlarge-t">{{
        'SERVICE_FORMS.NTServiceForms.fields.bagOptions.label' | finLocalization
      }}</label>
      <fin-form-input-checkbox-list
        [parentForm]="reactiveForm"
        class="flex--basis-full"
        [controlName]="'bagOptions'"
        [checkboxList]="bagOptionsControls"
      ></fin-form-input-checkbox-list>
      <fcom-text-input
        *ngIf="reactiveForm.get('combinationLockCode').enabled"
        [parentForm]="reactiveForm"
        [controlName]="'combinationLockCode'"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.combinationLockCode'"
      ></fcom-text-input>
    </div>
    <h3>{{ 'SERVICE_FORMS.NTServiceForms.baggageTrackingForm.descriptionOfContentHeading' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'baggageNameTagDescription'"
        [type]="TextInputType.TEXTAREA"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.baggageNameTagDescription'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'baggageIdentifiableFeatures'"
        [type]="TextInputType.TEXTAREA"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.baggageIdentifiableFeatures'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup mr-medium-b">
      <p>{{ 'SERVICE_FORMS.NTServiceForms.baggageTrackingForm.descriptionOfContentText' | finLocalization }}</p>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fin-form-array
        [parentForm]="reactiveForm"
        [controlName]="'bagItems'"
        [maxGroups]="6"
        [minGroups]="1"
        [formGroupConfig]="bagItemsFormGroupConfig"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.bagItems'"
      >
        <ng-template let-parentbBagItem="parentFormGroup" let-index="index">
          <div class="flex flex--row flex--wrap form-subgroup">
            <fcom-text-input
              [parentForm]="parentbBagItem"
              [controlName]="'itemName'"
              [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.itemName'"
              [id]="'bagItem_' + (index + 1) + '_itemName'"
            ></fcom-text-input>
            <fcom-text-input
              [parentForm]="parentbBagItem"
              [controlName]="'itemDescription'"
              [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.itemDescription'"
              [id]="'bagItem_' + (index + 1) + '_itemDescription'"
            ></fcom-text-input>
            <fin-select-input
              [parentForm]="parentbBagItem"
              [controlName]="'itemBelongsTo'"
              [options]="itemOwnerOptions$ | async"
              [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.itemBelongsTo'"
              [selectLabelTranslationKey]="'SERVICE_FORMS.NTServiceForms.select'"
            ></fin-select-input>
          </div>
        </ng-template>
      </fin-form-array>
    </div>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'itemsToIdentifyBaggage'"
        [type]="TextInputType.TEXTAREA"
        [translationPrefix]="'SERVICE_FORMS.NTServiceForms.fields.itemsToIdentifyBaggage'"
      ></fcom-text-input>
    </div>
    <div class="ps-small-t align-right">
      <fcom-button
        [type]="ButtonType.SUBMIT"
        [text]="'SERVICE_FORMS.NTServiceForms.submit' | finLocalization"
      ></fcom-button>
    </div>
  </form>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
  <!-- Success view -->
  <div *ngIf="formStatus === FormStatus.COMPLETE" class="mr-xlarge-t">
    <h2>{{ 'SERVICE_FORMS.NTServiceForms.success.title' | finLocalization }}</h2>
  </div>
</div>
